import React from "react";
import { Fab, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";

interface PurchaseFabProps {
  to: string;
  label?: string;
  sx?: any;
}

const PurchaseFab: React.FC<PurchaseFabProps> = ({
  to,
  label = "Purchase Now",
  sx,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Tooltip title={label} arrow placement="left">
      <Fab
        variant={isMobile ? "circular" : "extended"}
        color="primary"
        aria-label="purchase"
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          zIndex: 1000,
          backgroundColor: "#C0B283", // Gold color matching site theme
          color: "white",
          "&:hover": {
            backgroundColor: "#A89B6E",
            transform: "scale(1.05)",
          },
          transition: "transform 0.2s",
          ...sx,
        }}
        onClick={() => navigate(to)}
      >
        <ShoppingCartIcon sx={{ mr: isMobile ? 0 : 1 }} />
        {!isMobile && label}
      </Fab>
    </Tooltip>
  );
};

export default PurchaseFab;
